<div class="emitir-receta-container">
  <h2 *ngIf="!modoDialog">Emitir Receta Digital</h2>

  <!-- Formulario de emisión -->
  <div *ngIf="recetasGeneradas.length === 0">
    <!-- Buscador de Paciente (oculto si viene pre-seleccionado en modo dialog) -->
    <mat-card class="seccion-card" *ngIf="!pacienteInput">
      <mat-card-header>
        <mat-card-title>Paciente</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="!pacienteSeleccionado">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Buscar paciente por nombre, apellido o DNI</mat-label>
            <input
              matInput
              [(ngModel)]="filtroPaciente"
              (ngModelChange)="filtrarPacientes()"
              autocomplete="off"
            />
            <mat-icon matSuffix>person_search</mat-icon>
          </mat-form-field>
          <div *ngIf="pacientesFiltrados.length > 0" class="pacientes-lista">
            <div
              *ngFor="let p of pacientesFiltrados"
              class="paciente-item"
              (click)="seleccionarPaciente(p)"
            >
              <mat-icon>person</mat-icon>
              <span
                >{{ p.surname }}, {{ p.name }} - DNI:
                {{ p.numeroDocumento }}</span
              >
            </div>
          </div>
        </div>

        <div *ngIf="pacienteSeleccionado" class="paciente-seleccionado">
          <div class="paciente-info">
            <strong
              >{{ pacienteSeleccionado.surname }},
              {{ pacienteSeleccionado.name }}</strong
            >
            <span>DNI: {{ pacienteSeleccionado.numeroDocumento }}</span>
            <span>Obra Social: {{ pacienteSeleccionado.obraSocial }}</span>
          </div>
          <button
            mat-icon-button
            color="warn"
            (click)="limpiarPaciente()"
            matTooltip="Cambiar paciente"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Medicamentos -->
    <mat-card class="seccion-card">
      <mat-card-header>
        <mat-card-title>Medicamentos</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <!-- Lista de medicamentos agregados -->
        <div
          *ngFor="let med of medicamentos; let i = index"
          class="medicamento-row"
        >
          <div class="medicamento-info">
            <strong>{{ med.medication_name }}</strong>
            <span class="presentacion-text">{{ med.presentation }}</span>
          </div>
          <mat-form-field appearance="outline" class="cantidad-field">
            <mat-label>Cant.</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="med.cantidad"
              min="1"
              max="99"
            />
          </mat-form-field>
          <button
            mat-icon-button
            color="warn"
            (click)="eliminarMedicamento(i)"
            matTooltip="Eliminar medicamento"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <!-- Aviso de división -->
        <div *ngIf="medicamentos.length > 3" class="aviso-division">
          <mat-icon>info</mat-icon>
          <span
            >Se generarán {{ cantidadRecetas() }} recetas (máximo 3
            medicamentos por receta)</span
          >
        </div>

        <!-- Botón agregar -->
        <button
          mat-stroked-button
          color="primary"
          (click)="toggleBuscadorMedicamentos()"
          class="btn-agregar"
        >
          <mat-icon>add</mat-icon>
          {{ mostrarBuscadorMedicamentos ? "Cerrar buscador" : "Agregar medicamento" }}
        </button>

        <!-- Buscador de medicamentos -->
        <div *ngIf="mostrarBuscadorMedicamentos" class="buscador-container">
          <app-buscador-medicamentos
            (medicamentoSeleccionado)="onMedicamentoSeleccionado($event)"
          ></app-buscador-medicamentos>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Diagnóstico -->
    <mat-card class="seccion-card">
      <mat-card-header>
        <mat-card-title>Diagnóstico</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Diagnóstico</mat-label>
          <textarea
            matInput
            [formControl]="diagnosisControl"
            rows="3"
            placeholder="Ingrese el diagnóstico..."
          ></textarea>
          <mat-error *ngIf="diagnosisControl.hasError('required')">
            El diagnóstico es obligatorio
          </mat-error>
          <mat-error *ngIf="diagnosisControl.hasError('maxlength')">
            Máximo 500 caracteres
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <!-- Error -->
    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>

    <!-- Botón emitir -->
    <button
      mat-raised-button
      color="primary"
      (click)="emitirReceta()"
      [disabled]="procesando"
      class="btn-emitir"
    >
      <mat-icon>send</mat-icon>
      {{ procesando ? "Emitiendo..." : "Emitir Receta" }}
    </button>
  </div>

  <!-- Resultado: recetas generadas -->
  <div *ngIf="recetasGeneradas.length > 0" class="resultado-container">
    <div class="resultado-header">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h3>
        {{ recetasGeneradas.length === 1 ? "Receta emitida" : recetasGeneradas.length + " recetas emitidas" }}
        exitosamente
      </h3>
    </div>

    <mat-card
      *ngFor="let receta of recetasGeneradas; let i = index"
      class="receta-resultado-card"
    >
      <mat-card-header>
        <mat-card-title>Receta #{{ i + 1 }}</mat-card-title>
        <mat-card-subtitle *ngIf="receta.external_code"
          >Código: {{ receta.external_code }}</mat-card-subtitle
        >
      </mat-card-header>
      <mat-card-content>
        <div
          *ngFor="let med of receta.medicamentos"
          class="medicamento-resultado"
        >
          <span>{{ med.medication_name }}</span>
          <span class="presentacion-text">{{ med.presentation }}</span>
          <span>x{{ med.cantidad }}</span>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <span class="receta-creada-text">Receta creada correctamente</span>
      </mat-card-actions>
    </mat-card>

    <div class="acciones-resultado">
      <button
        *ngIf="puedeCompartir"
        mat-raised-button
        color="accent"
        (click)="compartirRecetas()"
        class="btn-compartir"
      >
        <mat-icon>share</mat-icon>
        Compartir por WhatsApp / Email
      </button>

      <button
        mat-raised-button
        color="primary"
        (click)="nuevaReceta()"
        class="btn-nueva"
      >
        <mat-icon>add</mat-icon>
        Emitir otra receta
      </button>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple">
  <p class="spinner-text">Emitiendo receta...</p>
</ngx-spinner>
